import { IOptionsHeaderType } from 'props';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Container } from './styles';

interface profileType {
  title: string;
  linkTo: string;
}

type DropDownNavBarProps = {
  name: string;
  typeHeader?: IOptionsHeaderType;
  isOpen: boolean;
  toggleDropdown: (name: string) => void;
  profiles?: profileType[];
};

export function DropDownNavBar({
  name,
  typeHeader,
  isOpen,
  toggleDropdown,
  profiles,
}: DropDownNavBarProps) {
  const handleClick = () => {
    toggleDropdown(name);
  };

  const getPaths = (type: IOptionsHeaderType) => {
    if (type === 'company') {
      return [
        {
          optionPath: '/collaborator',
          name: 'Colaboradores',
        },
        {
          optionPath: '/clients',
          name: 'Clientes',
        },
        {
          optionPath: '/courts',
          name: 'Varas e Juizados',
        },
        {
          optionPath: '/branch',
          name: 'Filiais',
        },
        {
          optionPath: '/department',
          name: 'Departamentos',
        },
        {
          optionPath: '/profiles',
          name: 'Perfis',
        },
        // {
        //   optionPath: '/correspondence',
        //   name: 'Serviços de correspondência',
        // },
        // {
        //   optionPath: '/specialties',
        //   name: 'Especialidades',
        // },
      ];
    }
    if (type === 'solicitation') {
      return [
        {
          optionPath: '/solicitation',
          name: 'Abrir solicitação',
        },
        {
          optionPath: '/yoursolicitations',
          name: 'Solicitações geradas',
        },
      ];
    }
    if (type === 'demand') {
      return [
        // {
        //   optionPath: '/demand',
        //   name: 'Registrar serviço externo',
        // },
        {
          optionPath: '/yourdemands',
          name: 'Suas demandas',
        },
      ];
    }
    if (type === 'report') {
      return [
        // {
        //   optionPath: '/dashboard',
        //   name: 'Dashboard',
        // },
        // {
        //   optionPath: '/financial',
        //   name: 'Financeiro',
        // },
      ];
    }
    return [];
  };

  return (
    <Container isOpen={isOpen}>
      <div
        className="dropdown-toggle"
        onClick={handleClick}
        onKeyDown={handleClick}
        role="presentation">
        {name}
        {isOpen ? <FaAngleUp /> : <FaAngleDown />}
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {getPaths(typeHeader).map((path) => (
            <div>
              <Link to={path.optionPath}>{path.name.toUpperCase()}</Link>
            </div>
          ))}
          {profiles &&
            profiles.map((item) => (
              <div>
                <Link to={item.linkTo}>{item.title.toUpperCase()}</Link>
              </div>
            ))}
        </div>
      )}
    </Container>
  );
}
